export default class CustomField {
  public type!: number
  public label!: string
  public description?: string | null
  public required!: boolean
  public equal!: string
  public value!: string
}
